export default "__VITE_ASSET__01578916__"